import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/solid";

export interface Props {
  page: number;
  totalPages: number;
  handlePagination: (page: number) => void;
}
export default function Pagination(props: Props) {
  const { page, totalPages, handlePagination } = props;
  const activeStyle = " border-blue-600 text-blue-600";
  const defaultStyle =
    " border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300";

  return (
    <>
      {totalPages > 1 && (
        <nav className="max-w-7xl flex items-center justify-between border-t border-gray-300 px-4 sm:px-0 mx-auto">
          <button
            className={
              "inline-flex items-center cursor-pointer border-t-2 pr-1 pt-4 text-sm font-medium" +
              defaultStyle
            }
            onClick={() => handlePagination(page - 1)}
            disabled={page === 1}
          >
            <ArrowLeftIcon
              className="mr-2 h-4 w-4 text-gray-400"
              aria-hidden="true"
            />
            Previous
          </button>

          <div className="hidden md:-mt-px md:flex">
            <button
              onClick={() => handlePagination(1)}
              type="button"
              className={
                "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                (page === 1 ? activeStyle : defaultStyle)
              }
            >
              {1}
            </button>

            {page > 3 && totalPages > 5 && (
              <div className="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500">
                ...
              </div>
            )}

            {page >= 4 && totalPages === 5 && (
              <button
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  (page === 2 ? activeStyle : defaultStyle)
                }
              >
                {2}
              </button>
            )}
            {page === totalPages && totalPages > 3 && (
              <button
                onClick={() => handlePagination(page - 2)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  defaultStyle
                }
              >
                {page - 2}
              </button>
            )}

            {page > 2 && (
              <button
                onClick={() => handlePagination(page - 1)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  defaultStyle
                }
              >
                {page - 1}
              </button>
            )}

            {page !== 1 && page !== totalPages && (
              <button
                onClick={() => handlePagination(page)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  activeStyle
                }
              >
                {page}
              </button>
            )}

            {page < totalPages - 1 && (
              <button
                onClick={() => handlePagination(page + 1)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  defaultStyle
                }
              >
                {page + 1}
              </button>
            )}

            {page === 1 && totalPages > 3 && (
              <button
                onClick={() => handlePagination(page + 2)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  defaultStyle
                }
              >
                {page + 2}
              </button>
            )}

            {page < totalPages - 2 && totalPages > 5 && (
              <div className="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500">
                ...
              </div>
            )}
            {page < 3 && totalPages === 5 && (
              <button
                onClick={() => handlePagination(totalPages - 1)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  defaultStyle
                }
              >
                {4}rn
              </button>
            )}

            {totalPages > 1 && (
              <button
                onClick={() => handlePagination(totalPages)}
                type="button"
                className={
                  "inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium" +
                  (page === totalPages ? activeStyle : defaultStyle)
                }
              >
                {totalPages}
              </button>
            )}
          </div>

          <button
            className={
              "inline-flex items-center cursor-pointer border-t-2 pl-1 pt-4 text-sm font-medium" +
              defaultStyle
            }
            onClick={() => handlePagination(page + 1)}
            disabled={page === totalPages}
          >
            Next
            <ArrowRightIcon
              className="ml-2 h-4 w-4 text-gray-400"
              aria-hidden="true"
            />
          </button>
        </nav>
      )}
    </>
  );
}
